import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {FormBuilder, FormControl} from '@angular/forms';
import {MatSelectChange} from '@angular/material/select';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {REGIONS} from '../../../../../constants/constants';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-country-vs-wf-filters',
  templateUrl: './country-vs-wf-filters.component.html',
  styleUrls: ['./country-vs-wf-filters.component.scss']
})
export class CountryVsWfFiltersComponent implements OnInit, OnChanges {

  regions = REGIONS;

  @ViewChild('allSelected') private allSelected!: MatOption;

  @Input()
  years!: number[];
  @Input()
  categories!: Master[];
  @Input()
  countryCategory!: string;

  searchForm = this.formBuilder.group({
    year: [''],
    categoryType: ['NEW'],
    categories: [''],
    member: [],
    region: [''],
    order: [],
    displayUnits: ['ABSOLUTE'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  get categoryTypeControl(): FormControl {
    return this.searchForm.get('categoryType') as FormControl;
  }

  get categoriesControl(): FormControl {
    return this.searchForm.get('categories') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }

  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();
  @Output()
  loadCategories: EventEmitter<string> = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.categories?.length) {
      if (changes.categories || !this.categoriesControl.value || this.categoriesControl.value.length === this.categories.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.categoriesControl
          .patchValue([...this.categories.map(item => item.id.toString()), 0]);
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      categoryType: this.categoryTypeControl.value,
      categories: this.categoriesControl.value,
      member: this.memberControl.value,
      region: this.regionControl.value,
      order: this.orderControl.value,
      displayUnits: this.searchForm.controls.displayUnits.value,
    };
    this.search.emit(search);
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.categoryTypeControl.setValue('NEW');
    this.categoriesControl.setValue('');
    this.memberControl.reset();
    this.regionControl.reset();
    this.orderControl.setValue(null);
    this.search.emit({startYear: this.years[0], categoryType: 'NEW', displayUnits: 'ABSOLUTE'});
  }

  getCategories(event: MatSelectChange): void {
    if (event?.value) {
      this.loadCategories.emit(event.value);
    }
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }

  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.categoriesControl
        .patchValue([...this.categories.map(item => item.id.toString()), 0]);
    } else {
      this.categoriesControl.patchValue([]);
    }
  }
}
